import Reveal from "@/components/Reveal";
import { Store, Briefcase, GraduationCap, Brain } from "lucide-react";

const profiles = [
  {
    icon: Store,
    title: "Tenés una marca o emprendimiento",
    desc: "Querés entender por qué la gente ve tu producto y no compra, o compra y no vuelve. Vas a trabajar directamente sobre tu marca.",
  },
  {
    icon: Briefcase,
    title: "Trabajás en marketing, publicidad o diseño",
    desc: "Querés sumar herramientas de neuromarketing a tu trabajo con clientes, ya sea en agencia, freelance o in-house. Vas a practicar con casos reales.",
  },
  {
    icon: GraduationCap,
    title: "Sos estudiante",
    desc: "Estás estudiando marketing, comunicación, psicología o diseño y querés aprender algo que no te enseñan en la facultad. Vas a practicar con las marcas de tus compañeros y con casos del mercado.",
  },
  {
    icon: Brain,
    title: "Te interesa el comportamiento del consumidor",
    desc: "No necesitás tener marca propia. Si te interesa entender cómo las personas toman decisiones de compra, este curso te da un framework para analizarlo.",
  },
];

const ParaQuien = () => (
  <section className="relative mx-auto max-w-7xl px-6 py-28 md:px-12 md:py-36" data-testid="para-quien-section">
    <Reveal className="mb-16 flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
      <div>
        <p className="mb-6 text-xs font-medium uppercase tracking-[0.35em] text-neoncyan">
          ¿Para quién es esto?
        </p>
        <h2 className="font-display text-4xl font-black uppercase leading-[0.95] tracking-tighter md:text-6xl">
          Este curso es <span className="text-magenta">para vos</span> si . . .
        </h2>
      </div>
    </Reveal>
    <div className="grid gap-4 sm:grid-cols-2">
      {profiles.map((p, i) => (
        <Reveal key={p.title} delay={i * 0.07}>
          <article
            className="group h-full border border-white/10 bg-black/30 p-8 transition-colors duration-500 hover:border-neoncyan/50 md:p-10"
            data-testid={`profile-card-${i + 1}`}
          >
            <div className="flex items-center justify-between">
              <p.icon className="h-6 w-6 text-magenta transition-colors duration-300 group-hover:text-neoncyan" />
              <span className="font-display text-xs font-bold uppercase tracking-[0.3em] text-lilac/40">
                0{i + 1}
              </span>
            </div>
            <h3 className="mt-8 font-display text-xl font-extrabold uppercase leading-tight tracking-tight md:text-2xl">
              {p.title}
            </h3>
            <p className="mt-4 text-sm leading-relaxed text-lilac/90">{p.desc}</p>
            <span className="mt-8 block h-px w-12 bg-white/20 transition-[width,background-color] duration-500 group-hover:w-24 group-hover:bg-neoncyan" />
          </article>
        </Reveal>
      ))}
    </div>
  </section>
);

export default ParaQuien;
